import React from 'react';
import { CompareTable } from './';

export default function CompareFunctionPositionFit({ employees }) {
  return (
    <CompareTable
      headers={['Candidate', 'FPF']}
      rows={employees.map((emp, i) => (
        <tr key={i}>
          <td>{emp.name}</td>
          <td>{emp.value}%</td>
        </tr>
      ))}
    />
  );
}
